import React from "react";
import { useModal, useVideo } from "../../context";
import {
  Header,
  Modal,
  NavBar,
  VideoCard,
  PlaylistForm,
} from "../../components";
import "../commonPage.css";
import "./explore.css";
import { useDocumentTitle } from "../../customHooks";

export const Explore = () => {
  useDocumentTitle("Home");
  const { videos } = useVideo()
  const { isModal, setIsModal } = useModal()
  return (
    <main className="page-main">
      <Header />
      <NavBar />
      <Modal showModal={isModal} setShowModal={setIsModal}>
        <PlaylistForm />
      </Modal>
      <section className="page-content padding-xs">
        <div className="videos-container">
          {videos.map((video) => (
            <VideoCard key={video._id} video={video} isExplore={true} />
          ))}
        </div>
      </section>
    </main>
  );
};
